import styled from '@emotion/styled'

export const Digit = styled.div`
  height: 2.8rem;
  width: 2.3rem;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border-radius: var(--theme-border-radius);
`

export const CountdownContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
`

export const CountdownItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const CountdownDigitsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  text-align: center;
`

export const HoursCountdownSeparator = styled.div`
  display: flex;

  align-content: center;
  align-items: center;
  justify-content: center;
`
